import LockClockSharp from '@mui/icons-material/LockClockSharp';
import { Box } from '@mui/material';
import { SLOT_LIST_DRAG_HANDLE_SIZE_PX } from './slot-list-layout';

/** Fixed start/end time indicator — same footprint as {@link SlotListDragHandle}. */
export default function SlotListLockIndicator() {
  return (
    <Box
      sx={{
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        minWidth: SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        height: SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        color: 'action.active',
      }}
      aria-hidden
    >
      <LockClockSharp sx={{ fontSize: 16 }} />
    </Box>
  );
}
